import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M10 9l-3 3l3 3","key":"svg-0"}],["path",{"d":"M14 9l3 3l-3 3","key":"svg-1"}]]

/**
 * IconDirectionHorizontal
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItZGlyZWN0aW9uLWhvcml6b250YWwiCj4KICA8cGF0aCBzdHJva2U9Im5vbmUiIGQ9Ik0wIDBoMjR2MjRIMHoiIGZpbGw9Im5vbmUiIC8+CiAgPHBhdGggZD0iTTEwIDlsLTMgM2wzIDMiIC8+CiAgPHBhdGggZD0iTTE0IDlsMyAzbC0zIDMiIC8+Cjwvc3ZnPg==) - https://tabler.io/icons/icon/direction-horizontal
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconDirectionHorizontal = createReactComponent('outline', 'direction-horizontal', 'DirectionHorizontal', __iconNode);

export default IconDirectionHorizontal;